import React, { useState } from "react";
import { FaAngleDown } from "react-icons/fa";

const CustomSelect = ({ options, selected, onSelect }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <div className="relative w-full">
        {/* Selected Item */}
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="flex items-center justify-between w-full bg-gray-700 text-white px-4 py-2 rounded-lg hover:bg-gray-600"
        >
          {selected.img ? (
            <div className="flex items-center space-x-2">
              <img
                src={selected.img}
                alt={selected.name}
                className="w-5 h-5 rounded-full"
              />
              <span>{selected.name}</span>
            </div>
          ) : (
            <span>Select an option</span>
          )}
          <span className="text-[18px]">
            <FaAngleDown />
          </span>
        </button>

        {/* Dropdown Options */}
        {isOpen && (
          <div className="absolute mt-2 w-full bg-gray-800 rounded-lg shadow-lg z-10">
            {options.map((option) => (
              <button
                key={option.value}
                className="flex items-center space-x-2 w-full px-4 py-2 text-left text-white hover:bg-gray-700"
                onClick={() => {
                  onSelect(option);
                  setIsOpen(false);
                }}
              >
                <img
                  src={option.img}
                  alt={option.symbol}
                  className="w-5 h-5 rounded-full"
                />
                <span>{option.symbol}</span>
              </button>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default CustomSelect;
